import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { Fragment, memo, useEffect, useState } from "react";
import { useApi } from "../hooks/useApi";

function ComboBox({ label, selection, onSelect, url, required, style, idTag, disabled }) {
  const [options, setOptions] = useState([]);

  const [open, setOpen] = useState(false);
  const loading = open && options.length === 0;

  const api = useApi();

  useEffect(() => {
    let active = true;

    api
      .get(url)
      .then(response => {
        if (!active) return;
        setOptions([...response.data])
      })
      .catch(error => {
        console.log(error);
      });

    return () => {
      active = false;
    };
  }, [loading, url]);

  const selectionHandler = (e) => {
    onSelect(e);
  };

  return (
    <Autocomplete
      onChange={(event, newValue) => {
        selectionHandler(newValue);
      }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      options={options}
      value={selection?.id === undefined ? null : selection}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      disablePortal
      id={`combo-box-${idTag}`}
      sx={style}
      loading={loading}
      disabled={disabled === undefined ? false : disabled}
      renderInput={(params) => (
        <TextField
          variant="outlined"
          size="small"
          required={required}
          {...params}
          label={label}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </Fragment>
            ),
          }}
        />
      )}
    />
  );
}

export default memo(ComboBox);